import {
  GetImageTitlesParamsType,
  GetImageTitlesResponseType,
} from '@/common/queries/selections/ImageTitles/getImageTitlesQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const getImageTitlesFunction = (
  params: GetImageTitlesParamsType,
): Promise<GetImageTitlesResponseType> => {
  return fetchApi.get('/selection_item/images_title/wop_list/', {
    params: {
      file_type: params.file_type ?? null,
      user_type: params.user_type ?? null,
      image_type: params.image_type ?? null,
      damaged_entity_type: params.damaged_entity_type ?? null,
      owner_type: params.owner_type ?? null,
      vehicle_type: params?.vehicle_type || null,
    },
  });
};
